const vHidden = 'v-hidden';
export default vHidden;
